import React, { useEffect, useState } from "react";
import { useCheckoutContext } from "lib/contexts/CheckoutProvider";
import { getTotalItems, getItemsTotalAndValue } from "lib/utils/checkout";
import { classNames, getStartNumberFromString } from "lib/utils/helpers";

interface CheckoutItemsCountProps {
  showOrderSummaryTotalTxt: boolean;
}

const CheckoutItemsCount: React.FC<CheckoutItemsCountProps> = ({ showOrderSummaryTotalTxt }) => {
  const {
    state: { checkoutItems, billing },
  } = useCheckoutContext();
  const [orderSummarySubTxt, setOrderSummarySubTxt] = useState<string>("");
  const [updatedCartItemsCount, setUpdatedCartItemsCount] = useState<number>(0);
  const [isItemChangeVisible, setIsItemChangeVisible] = useState<boolean>(false);

  useEffect(() => {
    if (!Boolean(billing)) return;
    const orderSummaryStr = getItemsTotalAndValue(
      checkoutItems,
      billing.total_payable,
      showOrderSummaryTotalTxt,
    );
    const cartItemsDifference = getTotalItems(checkoutItems) - getStartNumberFromString(orderSummarySubTxt);
    if (typeof orderSummarySubTxt === "string" && Boolean(cartItemsDifference)) {
      setUpdatedCartItemsCount(cartItemsDifference);
      setIsItemChangeVisible(true);
    }
    setTimeout(() => setIsItemChangeVisible(false), 1700);
    setTimeout(() => setUpdatedCartItemsCount(0), 2000);
    setOrderSummarySubTxt(orderSummaryStr);
  }, [billing, checkoutItems]);

  const renderUpdatedCartItemsCount = () => {
    return (
      <span
        className={classNames(
          "absolute w-max animate-fade-slide rounded-[4px]",
          updatedCartItemsCount ? "bg-yay-lighter px-1 text-yay-dark" : "bg-white",
        )}>
        {`${updatedCartItemsCount > 0 ? "+" : ""}${updatedCartItemsCount} ${
          Math.abs(updatedCartItemsCount) !== 1 ? "items" : "item"
        }`}
      </span>
    );
  };

  return (
    <div className="relative">
      {isItemChangeVisible && renderUpdatedCartItemsCount()}

      <span className={classNames(isItemChangeVisible ? "opacity-0" : "opacity-100")}>
        {orderSummarySubTxt}
      </span>
    </div>
  );
};

export default CheckoutItemsCount;
